import { ArrowRight, Phone, MapPin, Star } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxwb2xpc2hlZCUyMHNwb3J0cyUyMGNhciUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjUyMjAxOHww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] w-full overflow-hidden grain"
    >
      <img
        src={HERO_IMG}
        alt="Polished black sports car"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute bottom-0 left-0 right-0 h-32 hero-bottom-fade" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 min-h-[92vh] flex flex-col justify-center pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="fade-up flex items-center gap-3 mb-6">
            <span className="divider-red" />
            <span className="section-label">Tampa, FL · Mobile Detailing</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="fade-up delay-100 font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter"
          >
            We bring the
            <br />
            <span className="text-[#E63946]">showroom</span> to your driveway.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="fade-up delay-200 mt-6 max-w-xl text-zinc-300 text-base sm:text-lg leading-relaxed"
          >
            Barnett Auto Detailing is a fully mobile detailing service serving Tampa
            and the surrounding area. We hand-wash, polish and protect your vehicle —
            interior and out — wherever you are.
          </p>

          <div className="fade-up delay-300 mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-book"
              onClick={() => scrollTo("booking")}
              className="cta-glow inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#F0545E] text-white px-7 py-4 font-semibold tracking-wide"
            >
              Book a Detail
              <ArrowRight className="w-4 h-4" />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={() => scrollTo("services")}
              className="inline-flex items-center gap-2 border border-white/20 hover:border-white text-white px-7 py-4 font-semibold tracking-wide transition-colors"
            >
              View Packages
            </button>
          </div>

          <div className="fade-up delay-400 mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-zinc-400">
            <a
              href="tel:8134818875"
              data-testid="hero-phone-link"
              className="inline-flex items-center gap-2 hover:text-white transition-colors"
            >
              <Phone className="w-4 h-4 text-[#E63946]" />
              813-481-8875
            </a>
            <span className="inline-flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#E63946]" />
              Serving Tampa &amp; Surrounding Areas
            </span>
            <span className="inline-flex items-center gap-2">
              <Star className="w-4 h-4 text-[#E63946]" />
              Hand-Wash · Insured · Detail-Focused
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
